import { IonButton, IonContent, IonHeader, IonInput, IonLoading, IonPage, IonTitle, IonToolbar, useIonToast, IonItem, IonLabel, IonItemGroup } from '@ionic/react';
import { useState } from 'react';
import './Login.css';
import { loginUser, passwordReset } from '../firebase/firebase'
import { off } from 'process';

const Login: React.FC = () => {
  const [busy, setBusy] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [presentToast] = useIonToast();

  async function login() {
    setBusy(true);
    const res = await loginUser(username.trim(), password);
    if (!res) {
      presentToast({
        message: "Niepoprawne dane logowania!",
        duration: 2000,
        position: 'middle'
      });
    }
    setBusy(false);
  }

  async function reset() {
    setBusy(true);
    const res = await passwordReset(username);
    if (!res) {
      presentToast({
        message: "Niepoprawne dane do resetowania!",
        duration: 2000,
        position: 'middle'
      });
    } else {
      presentToast({
        message: "Sprawdź skrzynkę mailową!",
        duration: 2000,
        position: 'middle'
      });
    }
    setBusy(false);
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Logowanie</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonLoading message="Proszę czekać..." duration={0} isOpen={busy} />
      <IonContent style={{ maxWidth: "800px" }}>
        <IonItemGroup className="ion-padding">
          <IonItem>
            <IonLabel position="fixed">email</IonLabel>
            <IonInput placeholder='email' onIonChange={(e: any) => setUsername(e.target.value)} />
          </IonItem>
          <IonItem>
            <IonLabel position="fixed">hasło</IonLabel>
            <IonInput placeholder='hasło' type="password" onIonChange={(e: any) => setPassword(e.target.value)} onKeyDown={(key) => { if (key.code === "Enter") login() }} />
          </IonItem>
        </IonItemGroup>
        <IonItemGroup className="ion-padding">
          <IonButton style={{ width: "100%" }} onClick={login}>Login</IonButton>
        </IonItemGroup>
        <IonItemGroup className="ion-padding">
          <IonButton style={{ width: "100%" }} onClick={reset}>Resetowanie hasła</IonButton>
        </IonItemGroup>
      </IonContent>
    </IonPage>
  );
};

export default Login;
